import { FC } from "react";
import { IconPropsType } from ".";

export const ReportDetail: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.75 10.4286V11C1.75 12.1046 2.64543 13 3.75 13H11.75C12.8546 13 13.75 12.1046 13.75 11V5.5C13.75 4.39543 12.8546 3.5 11.75 3.5H4.25"
        stroke={props.color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4.75 6.25C4.33579 6.25 4 6.58579 4 7C4 7.41421 4.33579 7.75 4.75 7.75L4.75 6.25ZM13.75 6.25L4.75 6.25L4.75 7.75L13.75 7.75L13.75 6.25Z"
        fill={props.color}
      />
      <path
        d="M2.5 3.75C2.5 4.16421 2.16421 4.5 1.75 4.5C1.33579 4.5 1 4.16421 1 3.75C1 3.33579 1.33579 3 1.75 3C2.16421 3 2.5 3.33579 2.5 3.75Z"
        fill={props.color}
      />
      <path
        d="M2.5 5.75C2.5 6.16421 2.16421 6.5 1.75 6.5C1.33579 6.5 1 6.16421 1 5.75C1 5.33579 1.33579 5 1.75 5C2.16421 5 2.5 5.33579 2.5 5.75Z"
        fill={props.color}
      />
      <path
        d="M2.5 7.75C2.5 8.16421 2.16421 8.5 1.75 8.5C1.33579 8.5 1 8.16421 1 7.75C1 7.33579 1.33579 7 1.75 7C2.16421 7 2.5 7.33579 2.5 7.75Z"
        fill={props.color}
      />
    </svg>
  );
};
